export default "__VITE_ASSET__DDaJJxki__"